import { getArrayCopy, dashedAttr2CSSMap, loadRefImage, showRecursively } from './raphael.lib';
export default function (n) {
  if (n.svg) {
    var e = {
      visibility: 'hidden',
      "font-size": '0px'
    },
        t = String,
        r = parseFloat,
        i = parseInt,
        o = {
      top: 0,
      bottom: -1,
      middle: -.5
    },
        a = n._g.win,
        s = a.navigator,
        d = !!document.documentMode,
        l = Math,
        p = l.max,
        c = l.abs,
        h = l.pow,
        f = l.sqrt,
        u = /^xlink:/,
        g = /[, ]+/,
        y = /\n|<br\s*?\/?>/i,
        _ = /&lt|&gt|<br/i,
        m = Array.prototype.shift,
        v = !!(/AppleWebKit/.test(s.userAgent) && (!/Chrome/.test(s.userAgent) || 29 > s.appVersion.match(/Chrome\/(\d+)\./)[1])),
        b = n.eve,
        w = !!s.platform && /iPad|iPhone|iPod/.test(s.platform),
        x = {
      block: 'M5,0 0,2.5 5,5z',
      classic: 'M5,0 0,2.5 5,5 3.5,3 3.5,2z',
      diamond: 'M2.5,0 5,2.5 2.5,5 0,2.5z',
      open: 'M6,1 1,3.5 6,6',
      oval: 'M2.5,0A2.5,2.5,0,0,1,2.5,5 2.5,2.5,0,0,1,2.5,0z'
    },
        k = {
      speed: 'optimizeSpeed',
      crisp: 'crispEdges',
      precision: 'geometricPrecision'
    },
        C = s.userAgent.toLowerCase(),
        A = function () {
      var e = -1 != C.indexOf('msie') && parseInt(C.split('msie')[1]);
      return !!(e && 9 === e);
    }(),
        S = n.supportsPointer,
        L = n.supportsTouch,
        E = {},
        P = function P(e, t, r, i) {
      n._preload(r[1], function () {
        var r = this.offsetWidth,
            a = this.offsetHeight;
        O(e, {
          width: r,
          height: a
        }), O(t, {
          width: r,
          height: a
        }), i.safari();
      });
    },
        B = function B(e, t) {
      if (t) for (var r in t) {
        e[r] = t[r];
      }
    },
        N = {
      elementInfo: []
    },
        T = n._g.doc,
        a = n._g.win,
        D = {
      mouseover: 'touchstart',
      mousedown: 'touchstart',
      mouseup: 'touchend',
      mousemove: 'touchmove',
      mouseout: 'touchend'
    };

    L && T.addEventListener(S ? 'pointerover' : 'touchstart', function (t) {
      if (N.srcElement && N.srcElement !== (t.srcElement || t.target)) {
        var e,
            r,
            a,
            e = N.elementInfo,
            n = e.length;

        for (a = 0; a < n; a++) {
          r = e[a], r.callback.call(r.el, t);
        }
      }

      N = {
        elementInfo: []
      };
    }, !0), n.toString = function () {
      return 'Your browser supports SVG.\nYou are running Rapha\xEBl ' + this.version;
    }, n._url = '';

    var I = function I(e, t) {
      var r = e.gradient;

      if (r) {
        if (r === t) return;
        r.refCount--, r.refCount || r.parentNode.removeChild(r), delete e.gradient;
      }

      t && (e.gradient = t, t.refCount++);
    },
        O = n._createNode = function (e, r) {
      if ('string' == typeof e && (e = n._g.doc.createElementNS('http://www.w3.org/2000/svg', e)), r) {
        var i, a;

        for (i in r) {
          a = A ? t(r[i]) : r[i], u.test(i) ? e.setAttributeNS('http://www.w3.org/1999/xlink', i.replace(u, ''), a) : e.setAttribute(i, a);
        }
      }

      return e;
    },
        M = {
      userSpaceOnUse: 'userSpaceOnUse',
      objectBoundingBox: 'objectBoundingBox'
    },
        z = {
      pad: 'pad',
      redlect: 'reflect',
      repeat: 'repeat'
    },
        R = function R(e, a) {
      if (!e.paper || !e.paper.defs) return 0;

      var d,
          u,
          g,
          y,
          _,
          m,
          v = 'linear',
          w = e.paper,
          x = n.getElementID((w.id + '-' + a).replace(/[()\s%:,\xb0#]/g, '_')),
          b = .5,
          k = .5,
          C = e.node,
          o = C.style,
          s = n._g.doc.getElementById(x);

      if (!s) {
        if (a = t(a).replace(n._radial_gradient, function (e, t) {
          v = 'radial', t = t ? t.split(',') : [], y = t[5], _ = t[6];
          var i,
              a,
              n = t[0],
              o = t[1],
              s = t[2],
              l = t[3],
              p = t[4],
              c = n && o;
          return (s && (d = /%/.test(s) ? s : r(s)), y === M.userSpaceOnUse) ? (c && (b = n, k = o), l && p && (u = l, g = p, !c && (b = u, k = g)), '') : (c && (b = r(n), k = r(o), i = 2 * (.5 < k) - 1, .25 < (a = h(b - .5, 2)) + h(k - .5, 2) && .25 > a && (k = f(.25 - a) * i + .5) && .5 !== k && (k = k.toFixed(5) - 1e-5 * i)), l && p && (u = r(l), g = r(p), i = 2 * (.5 < g) - 1, .25 < (a = h(u - .5, 2)) + h(g - .5, 2) && .25 > a && (g = f(.25 - a) * i + .5) && .5 !== g && (g = g.toFixed(5) - 1e-5 * i), !c && (b = u, k = g)), '');
        }), a = a.split(/\s*-\s*/), 'linear' == v) {
          var A,
              S = a.shift(),
              L = S.match(/\((.*)\)/);
          if (L = L && L[1] && L[1].split(/\s*,\s*/), S = -r(S), isNaN(S)) return null;
          L && L.length ? (L[0] in M ? (y = L.shift(), L[0] in z && (_ = L.shift())) : (L[4] && (y = L[4]), L[5] && (_ = L[5])), m = [L[0] || '0%', L[1] || '0%', L[2] || '100%', L[3] || '0%']) : (m = [0, 0, l.cos(n.rad(S)), l.sin(n.rad(S))], A = 1 / (p(c(m[2]), c(m[3])) || 1), m[2] *= A, m[3] *= A, 0 > m[2] && (m[0] = -m[2], m[2] = 0), 0 > m[3] && (m[1] = -m[3], m[3] = 0));
        }

        var E = n._parseDots(a);

        if (!E) return null;
        s = O(v + 'Gradient', {
          id: x
        }), s.refCount = 0, y in M && s.setAttribute('gradientUnits', t(y)), _ in z && s.setAttribute('spreadMethod', t(_)), 'radial' == v ? (void 0 !== d && s.setAttribute('r', t(d)), void 0 !== u && void 0 !== g && (s.setAttribute('cx', t(u)), s.setAttribute('cy', t(g))), s.setAttribute('fx', t(b)), s.setAttribute('fy', t(k))) : O(s, {
          x1: m[0],
          y1: m[1],
          x2: m[2],
          y2: m[3]
        });

        for (var P = 0, B = E.length; P < B; P++) {
          s.appendChild(O('stop', {
            offset: E[P].offset ? E[P].offset : P ? '100%' : '0%',
            "stop-color": E[P].color || '#fff',
            "stop-opacity": void 0 === E[P].opacity ? 1 : E[P].opacity
          }));
        }

        w.defs.appendChild(s);
      }

      return I(e, s), O(C, {
        fill: 'url(\'' + n._url + '#' + x + '\')',
        "fill-opacity": 1
      }), o.fill = '', 1;
    },
        U = function U(e) {
      var t = e.getBBox(1);
      O(e.pattern, {
        patternTransform: e.matrix.invert() + ' translate(' + t.x + ',' + t.y + ')'
      });
    },
        H = function H(e, r, a) {
      if ('path' == e.type) {
        for (var o, s, d, l, c, f = t(r).toLowerCase().split('-'), u = e.paper, p = a ? 'end' : 'start', g = e.node, y = e.attrs, _ = y['stroke-width'], m = f.length, v = 'classic', b = 3, k = 3, C = 5; m--;) {
          switch (f[m]) {
            case 'block':
            case 'classic':
            case 'oval':
            case 'diamond':
            case 'open':
            case 'none':
              v = f[m];
              break;

            case 'wide':
              k = 5;
              break;

            case 'narrow':
              k = 2;
              break;

            case 'long':
              b = 5;
              break;

            case 'short':
              b = 2;
          }
        }

        if ('open' == v ? (b += 2, k += 2, C += 2, d = 1, l = a ? 4 : 1, c = {
          fill: 'none',
          stroke: y.stroke
        }) : (l = d = b / 2, c = {
          fill: y.stroke,
          stroke: 'none'
        }), e._.arrows ? a ? (e._.arrows.endPath && E[e._.arrows.endPath]--, e._.arrows.endMarker && E[e._.arrows.endMarker]--) : (e._.arrows.startPath && E[e._.arrows.startPath]--, e._.arrows.startMarker && E[e._.arrows.startMarker]--) : e._.arrows = {}, 'none' != v) {
          var A = 'raphael-marker-' + v,
              S = 'raphael-marker-' + p + v + b + k + '-obj' + e.id;
          n._g.doc.getElementById(A) ? E[A]++ : (u.defs.appendChild(O(O('path'), {
            "stroke-linecap": 'round',
            d: x[v],
            id: A
          })), E[A] = 1);

          var L,
              P = n._g.doc.getElementById(S);

          P ? (E[S]++, L = P.getElementsByTagName('use')[0]) : (P = O(O('marker'), {
            id: S,
            markerHeight: k,
            markerWidth: b,
            orient: 'auto',
            refX: l,
            refY: k / 2
          }), L = O(O('use'), {
            "xlink:href": '#' + A,
            transform: (a ? 'rotate(180 ' + b / 2 + ' ' + k / 2 + ') ' : '') + 'scale(' + b / C + ',' + k / C + ')',
            "stroke-width": (1 / ((b / C + k / C) / 2)).toFixed(4)
          }), P.appendChild(L), u.defs.appendChild(P), E[S] = 1), O(L, c);
          var B = d * ('diamond' != v && 'oval' != v);
          a ? (o = e._.arrows.startdx * _ || 0, s = n.getTotalLength(y.path) - B * _) : (o = B * _, s = n.getTotalLength(y.path) - (e._.arrows.enddx * _ || 0)), c = {}, c['marker-' + p] = 'url(\'' + n._url + '#' + S + '\')', (s || o) && (c.d = n.getSubpath(y.path, o, s)), O(g, c), e._.arrows[p + 'Path'] = A, e._.arrows[p + 'Marker'] = S, e._.arrows[p + 'dx'] = B, e._.arrows[p + 'Type'] = v, e._.arrows[p + 'String'] = r;
        } else a ? (o = e._.arrows.startdx * _ || 0, s = n.getTotalLength(y.path) - o) : (o = 0, s = n.getTotalLength(y.path) - (e._.arrows.enddx * _ || 0)), e._.arrows[p + 'Path'] && O(g, {
          d: n.getSubpath(y.path, o, s)
        }), delete e._.arrows[p + 'Path'], delete e._.arrows[p + 'Marker'], delete e._.arrows[p + 'dx'], delete e._.arrows[p + 'Type'], delete e._.arrows[p + 'String'];

        for (c in E) {
          if (E.hasOwnProperty(c) && !E[c]) {
            var N = n._g.doc.getElementById(c);

            N && N.parentNode.removeChild(N);
          }
        }
      }
    },
        F = {
      "": ['none'],
      none: ['none'],
      "-": [3, 1],
      ".": [1, 1],
      "-.": [3, 1, 1, 1],
      "-..": [3, 1, 1, 1, 1, 1],
      ". ": [1, 3],
      "- ": [4, 3],
      "--": [8, 3],
      "- .": [4, 3, 1, 3],
      "--.": [8, 3, 1, 3],
      "--..": [8, 3, 1, 3, 1, 3]
    },
        V = function V(e, t, r) {
      if (void 0 !== t) {
        var a,
            o,
            s,
            d,
            l,
            p = F[t.toLowerCase && t.toLowerCase()];

        if (t = p || [].concat(t), n.is(t, 'array')) {
          if (o = r['stroke-width'] || e.attrs['stroke-width'] || 1, s = {
            round: o,
            square: o,
            butt: 0
          }[r['stroke-linecap'] || e.attrs['stroke-linecap']] || 0, d = t.length, l = p ? o : 1, 'none' === t[0]) a = t;else for (a = []; d--;) {
            a[d] = t[d] * l + (d % 2 ? 1 : -1) * s, 0 >= a[d] && (a[d] = .01 + (1 >= o ? s : 0)), isNaN(a[d]) && (a[d] = 0);
          }
          return {
            "stroke-dasharray": a.join(',')
          };
        }
      }
    },
        G = n._setFillAndStroke = function (e, r) {
      if (e.paper.canvas) {
        var a,
            o,
            s,
            d,
            l,
            h,
            f = e.node,
            u = e.attrs,
            y = e.paper,
            _ = {},
            m = {};

        for (o in 'image' === e.type && loadRefImage(e, r), r) {
          if (o in n._availableAttrs) if (s = r[o], '' === s && o in u) delete u[o], f.removeAttribute('src' === o ? 'href' : o);else switch (u[o] = s, o) {
            case 'blur':
              e.blur(s);
              break;

            case 'href':
            case 'title':
            case 'target':
              var w = f.parentNode;

              if ('a' !== w.tagName.toLowerCase()) {
                if ('' === s) break;
                var x = O('a');
                x.raphael = !0, x.raphaelid = f.raphaelid, w.insertBefore(x, f), x.appendChild(f), w = x;
              }

              'target' === o ? w.setAttributeNS('http://www.w3.org/1999/xlink', 'show', 'blank' === s ? 'new' : s) : w.setAttributeNS('http://www.w3.org/1999/xlink', o, s), f.titleNode = w;
              break;

            case 'cursor':
              m.cursor = s;
              break;

            case 'transform':
              e.transform(s);
              break;

            case 'rotation':
              n.is(s, 'array') ? e.rotate.apply(e, s) : e.rotate(s);
              break;

            case 'arrow-start':
              H(e, s);
              break;

            case 'arrow-end':
              H(e, s, 1);
              break;

            case 'clip-path':
              d = !0;

            case 'clip-rect':
              if (h = !d && t(s).split(g), e._.clipispath = !!d, d || 4 === h.length) {
                e.clip && e.clip.parentNode.parentNode.removeChild(e.clip.parentNode);
                var b = O(d ? 'path' : 'rect');
                a = O('clipPath'), a.id = n.getElementID(n.createUUID()), O(b, d ? {
                  d: s ? u['clip-path'] = n._pathToAbsolute(s) : n._availableAttrs.path,
                  fill: 'none'
                } : {
                  x: h[0],
                  y: h[1],
                  width: h[2],
                  height: h[3],
                  transform: e.matrix.invert()
                }), a.appendChild(b), y.defs.appendChild(a), _['clip-path'] = 'url(\'' + n._url + '#' + a.id + '\')', e.clip = b;
              }

              if (!s) {
                var C = f.getAttribute('clip-path');

                if (C) {
                  var A = n._g.doc.getElementById(C.replace(/(^url\(#|\)$)/g, ''));

                  A && A.parentNode.removeChild(A), _['clip-path'] = '', 11 === document.documentMode && f.removeAttribute('clip-path'), delete e.clip;
                }
              }

              break;

            case 'path':
              'path' === e.type && (_.d = s ? u.path = n._stopabsolutePath ? n.sanitizePath(s) : n._pathToAbsolute(s) : n._availableAttrs.path, e._.dirty = 1, e._.arrows && ('startString' in e._.arrows && H(e, e._.arrows.startString), 'endString' in e._.arrows && H(e, e._.arrows.endString, 1)));
              break;

            case 'width':
              if (_[o] = s, e._.dirty = 1, u.fx) o = 'x', s = u.x;else break;

            case 'x':
              u.fx && (s = -u.x - (u.width || 0));

            case 'rx':
              if ('rx' === o && 'rect' === e.type) break;

            case 'cx':
              _[o] = s, e.pattern && U(e), e._.dirty = 1;
              break;

            case 'height':
              if (_[o] = s, e._.dirty = 1, u.fy) o = 'y', s = u.y;else break;

            case 'y':
              if ('text' === e.type) break;
              u.fy && (s = -u.y - (u.height || 0));

            case 'ry':
              if ('ry' === o && 'rect' === e.type) break;

            case 'cy':
              _[o] = s, e.pattern && U(e), e._.dirty = 1;
              break;

            case 'r':
              'rect' === e.type ? _.rx = _.ry = s : _[o] = s, e._.dirty = 1;
              break;

            case 'src':
              'image' === e.type && f.setAttributeNS('http://www.w3.org/1999/xlink', 'href', s);
              break;

            case 'stroke-width':
              (1 !== e._.sx || 1 !== e._.sy) && (s /= p(c(e._.sx), c(e._.sy)) || 1), y._vbSize && (s *= y._vbSize), v && 0 === s && (s = 1e-6), _[o] = s, !r['stroke-dasharray'] && u['stroke-dasharray'] && B(_, V(e, u['stroke-dasharray'], r)), e._.arrows && ('startString' in e._.arrows && n.addArrow && n.addArrow(e, e._.arrows.startString), 'endString' in e._.arrows && n.addArrow && n.addArrow(e, e._.arrows.endString, 1));
              break;

            case 'stroke-dasharray':
              B(_, V(e, s, r));
              break;

            case 'fill':
              var S = n._ISURL.test(s);

              if (S) {
                l = s.split(n._ISURL), a = O('pattern');
                var L = O('image');
                a.id = n.getElementID(n.createUUID()), O(a, {
                  x: 0,
                  y: 0,
                  patternUnits: 'userSpaceOnUse',
                  height: 1,
                  width: 1
                }), O(L, {
                  x: 0,
                  y: 0,
                  "xlink:href": l[1]
                }), a.appendChild(L), P(a, L, l, y), y.defs.appendChild(a), _.fill = 'url(\'' + n._url + l[1] + '\')', e.pattern = a, e.pattern && U(e);
                break;
              }

              var E = n.getRGB(s);
              if (!E.error) delete r.gradient, delete u.gradient, !n.is(u['fill-opacity'], 'undefined') && n.is(r['fill-opacity'], 'undefined') && (_['fill-opacity'] = u['fill-opacity']), e.gradient && I(e);else if (('circle' === e.type || 'ellipse' === e.type || 'r' !== t(s).charAt()) && R(e, s)) {
                u.gradient = s;
                break;
              }
              E.hasOwnProperty('opacity') ? (_['fill-opacity'] = 1 < E.opacity ? E.opacity / 100 : E.opacity, e._.fillOpacityDirty = !0) : e._.fillOpacityDirty && n.is(u['fill-opacity'], 'undefined') && n.is(r['fill-opacity'], 'undefined') && (f.removeAttribute('fill-opacity'), delete e._.fillOpacityDirty);

            case 'stroke':
              E = n.getRGB(s), _[o] = E.hex, 'stroke' === o && (E.hasOwnProperty('opacity') ? (_['stroke-opacity'] = 1 < E.opacity ? E.opacity / 100 : E.opacity, e._.strokeOpacityDirty = !0) : e._.strokeOpacityDirty && n.is(u['stroke-opacity'], 'undefined') && n.is(r['stroke-opacity'], 'undefined') && (f.removeAttribute('stroke-opacity'), delete e._.strokeOpacityDirty), e._.arrows && ('startString' in e._.arrows && H(e, e._.arrows.startString), 'endString' in e._.arrows && H(e, e._.arrows.endString, 1)));
              break;

            case 'gradient':
              ('circle' === e.type || 'ellipse' === e.type || 'r' !== t(s).charAt()) && R(e, s);
              break;

            case 'visibility':
              'hidden' === s ? e.hide() : e.show();
              break;

            case 'opacity':
              s = 1 < s ? s / 100 : s, _.opacity = s;
              break;

            case 'fill-opacity':
              s = 1 < s ? s / 100 : s, _['fill-opacity'] = s;
              break;

            case 'shape-rendering':
              e.attrs[o] = s = k[s] || s || 'auto', _[o] = s, f.style.shapeRendering = s;
              break;

            case 'line-height':
            case 'vertical-align':
              break;

            default:
              'font-size' === o && (s = i(s, 10) + 'px'), e._.dirty = 1, _[o] = s, dashedAttr2CSSMap[o] && (m[dashedAttr2CSSMap[o]] = s);
          }
        }

        for (o in m) {
          f.style[o] = m[o];
        }

        for (o in _) {
          f.setAttribute(o, _[o]);
        }

        'text' !== e.type || r['_do-not-tune'] || j(e, r);
      }
    },
        Y = n._updateFollowers = function () {
      var e,
          t,
          r,
          a = getArrayCopy(arguments),
          n = m.call(a),
          o = m.call(a);

      for (e = 0, t = n.followers.length; e < t; e++) {
        r = n.followers[e].el, r[o].apply(r, a);
      }
    },
        j = function j(s, p) {
      if ('text' === s.type && (p.hasOwnProperty('text') || p.hasOwnProperty('font') || p.hasOwnProperty('font-size') || p.hasOwnProperty('x') || p.hasOwnProperty('y') || p.hasOwnProperty('line-height') || p.hasOwnProperty('vertical-align'))) {
        var c,
            h,
            f,
            u,
            g,
            m,
            v,
            w,
            x,
            b,
            k,
            C = s.attrs,
            a = s.parent,
            A = s.node,
            S = s._oldAttr = s._oldAttr || {
          baseLineDiff: 8,
          valign: -.5
        },
            L = r(p['line-height'] || C['line-height']),
            E = p.direction || C.direction || a && a.attrs && a.attrs.direction || S.direction || 'initial',
            P = !1,
            B = !1,
            N = d || 'rtl' !== E ? 1 : 2,
            T = !1,
            D = !1,
            I = !d && S.direction && E !== S.direction;
        if (S.direction = E, L || (c = p.fontSize || p['font-size'] || C['font-size'] || a && a.attrs && a.attrs.fontSize, c = c ? c.toString().replace('px', '') : 10, L = c * 1.2), p.hasOwnProperty('text') && (k = n.is(p.text, 'array') ? p.text.join('<br>') : p.text, k !== S.text && (D = !0, k && _.test(k) && (k = k.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&<br\/>lt;|&l<br\/>t;|&lt<br\/>;/g, '<<br/>').replace(/&<br\/>gt;|&g<br\/>t;|&gt<br\/>;/g, '><br/>')), S.text = C.text = k, y.test(k) ? (S.noTSpan && (S.noTSpan = !(I = !0)), v = t(k).split(y), g = v.length) : (I = !0, S.noTSpan = !0, g = 1), S.lineCount !== g && (S.lineCount = g, T = !0))), L !== S.lineHeight && (S.lineHeight = L, S.baseLineDiff = .75 * L, T = !0), I) for (; A.firstChild;) {
          A.removeChild(A.firstChild);
        }
        if (!(1 < S.lineCount)) D && A.appendChild(n._g.doc.createTextNode(k));else if (f = {}, S.tspanAttr || (S.tspanAttr = {}, S.tspan0Attr = {}), S.tspanAttr.dy !== S.lineHeight && (S.tspanAttr.dy = f.dy = S.lineHeight, B = !0), p.hasOwnProperty('x') && S.tspanAttr.x !== p.x && (S.tspan0Attr.x = S.tspanAttr.x = f.x = C.x, B = !0), D) {
          for (b = A.getElementsByTagName('tspan'), u = 0; u < g; u++) {
            if (x = b[u * N], x) {
              if (x.innerHTML = '', d) for (; x.firstChild;) {
                x.removeChild(x.firstChild);
              }
              B && O(x, u ? f : S.tspan0Attr);
            } else x = O('tspan', u ? S.tspanAttr : S.tspan0Attr), A.appendChild(x), d || 'rtl' !== E || (w = O('tspan', e), w.appendChild(n._g.doc.createTextNode('i')), A.appendChild(w));

            v[u] || (x.setAttributeNS('http://www.w3.org/XML/1998/namespace', 'xml:space', 'preserve'), v[u] = ' '), x.appendChild(n._g.doc.createTextNode(v[u]));
          }

          if (m = g * N, b.length > m) for (u = b.length - 1; u >= m; u -= 1) {
            A.removeChild(b[u]);
          }
        } else if (B) for (b = A.getElementsByTagName('tspan'), m = b.length, u = 0; u < m; u += N) {
          O(b[u], u ? f : S.tspan0Attr);
        }
        p['vertical-align'] && (h = o[C['vertical-align']] || 0, h !== S.valign && (S.valign = h, T = !0)), T && (S.shift = S.baseLineDiff + S.lineCount * S.lineHeight * S.valign, P = !0), (p.y || 0 === p.y) && S.y !== p.y && (S.y = C.y, P = !0), P && (S.y || 0 === S.y) && (S.shift || 0 === S.shift) && O(A, {
          y: Math.round(S.y + S.shift)
        });
      }
    },
        X = function X(e, t, r) {
      var i = this,
          a = r || t;
      a.canvas && a.canvas.appendChild(e), i.node = i[0] = e, e.raphael = !0, e.raphaelid = i.id = n._oid++, i.matrix = n.matrix(), i.realPath = null, i.attrs = i.attrs || {}, i.followers = i.followers || [], i.paper = t, i.ca = i.customAttributes = i.customAttributes || new t._CustomAttributes(), i._ = {
        transform: [],
        sx: 1,
        sy: 1,
        deg: 0,
        dx: 0,
        dy: 0,
        dirty: 1
      }, i.parent = a, a.bottom || (a.bottom = i), i.prev = a.top, a.top && (a.top.next = i), a.top = i, i.next = null;
    },
        W = function W(e, t, r) {
      var i = r ? 'pageY' : 'pageX';
      return Math.abs(t[i] - e[i]);
    },
        q = n.storeHandlers = function (e, t, r) {
      e._actualListners || (e._actualListners = []), e._derivedListeners || (e._derivedListeners = []), e._actualListners.push(t), e._derivedListeners.push(r);
    },
        Q = function Q(e, t) {
      var r,
          i = e._actualListners.indexOf(t);

      return -1 !== i && (r = e._derivedListeners[i], e._actualListners.splice(i, 1), e._derivedListeners.splice(i, 1)), r;
    },
        J = n.el;

    X.prototype = J, J.constructor = X, n._engine.getNode = function (e) {
      var t = e.node || e[0].node;
      return t.titleNode || t;
    }, n._engine.getLastNode = function (e) {
      var t = e.node || e[e.length - 1].node;
      return t.titleNode || t;
    }, J.rotate = function (e, i, a) {
      var n,
          s = this;
      return s.removed ? s : (Y(s, 'rotate', e, i, a), e = t(e).split(g), e.length - 1 && (i = r(e[1]), a = r(e[2])), e = r(e[0]), null == a && (i = a), (null == i || null == a) && (n = s.getBBox(1), i = n.x + n.width / 2, a = n.y + n.height / 2), s.transform(s._.transform.concat([['r', e, i, a]])), s);
    }, J.scale = function (e, i, a, n) {
      var s,
          d = this;
      return d.removed ? d : (Y(d, 'scale', e, i, a, n), e = t(e).split(g), e.length - 1 && (i = r(e[1]), a = r(e[2]), n = r(e[3])), e = r(e[0]), null == i && (i = e), null == n && (a = n), (null == a || null == n) && (s = d.getBBox(1)), a = null == a ? s.x + s.width / 2 : a, n = null == n ? s.y + s.height / 2 : n, d.transform(d._.transform.concat([['s', e, i, a, n]])), d);
    }, J.translate = function (e, i) {
      var a = this;
      return a.removed ? a : (Y(a, 'translate', e, i), e = t(e).split(g), e.length - 1 && (i = r(e[1])), e = r(e[0]) || 0, i = +i || 0, a.transform(a._.transform.concat([['t', e, i]])), a);
    }, J.transform = function (e) {
      var t,
          r = this,
          i = r._;
      return null == e ? i.transform : (n._extractTransform(r, e), r.clip && !i.clipispath && O(r.clip, {
        transform: r.matrix.invert()
      }), r.pattern && U(r), r.node && O(r.node, {
        transform: r.matrix
      }), (1 !== i.sx || 1 !== i.sy) && (t = r.attrs['stroke-width'], t && r.attr({
        "stroke-width": t
      })), r);
    }, J.hide = function () {
      var e = this;
      return Y(e, 'hide'), e.removed || e.paper.safari(e.node.style.display = 'none'), e;
    }, J.show = function () {
      var e = this;
      return Y(e, 'show'), e.removed || e.paper.safari(e.node.style.display = ''), e;
    }, J.remove = function () {
      if (!this.removed && this.parent.canvas) {
        var e,
            t = this,
            r = n._engine.getNode(t),
            a = t.paper,
            o = a.defs;

        for (a.__set__ && a.__set__.exclude(t), b.unbind('raphael.*.*.' + t.id), t.gradient && o && I(t); e = t.followers.pop();) {
          e.el.remove();
        }

        for (; e = t.bottom;) {
          e.remove();
        }

        if (t._drag && t.undrag(), t.events) for (; e = t.events.pop();) {
          e.unbind();
        }

        for (e in t.parent.canvas.contains(r) && t.parent.canvas.removeChild(r), t.removeData(), delete a._elementsById[t.id], n._tear(t, t.parent), t) {
          t[e] = 'function' == typeof t[e] ? n._removedFactory(e) : null;
        }

        t.removed = !0;
      }
    }, J._getBBox = function () {
      var e,
          t,
          r,
          i = this,
          n = i.node,
          o = {},
          s = i.attrs,
          a = 'text' === i.type;
      d && a ? e = showRecursively(i) : 'none' === n.style.display && (i.show(), r = !0);

      try {
        o = n.getBBox(), a && (void 0 === o.x && (o.isCalculated = !0, t = s['text-anchor'], o.x = (s.x || 0) - o.width * ('start' === t ? 0 : 'middle' === t ? .5 : 1)), void 0 === o.y && (o.isCalculated = !0, t = s['vertical-align'], o.y = (s.y || 0) - o.height * ('bottom' === t ? 1 : 'middle' === t ? .5 : 0)));
      } catch (t) {} finally {
        o = o || {};
      }

      return d && a ? e && e() : r && i.hide(), o;
    }, J.attr = function (e, t) {
      if (this.removed) return this;
      var r,
          a,
          o,
          s,
          d,
          l,
          p,
          c,
          h = this,
          f = this.attrs,
          u = {},
          g = h._invokedCa || (h._invokedCa = {}),
          y = this.ca;

      if (null == e) {
        var _ = {};

        for (r in f) {
          f.hasOwnProperty(r) && (_[r] = f[r]);
        }

        return _.gradient && 'none' === _.fill && (_.fill = _.gradient) && delete _.gradient, _.transform = this._.transform, _.visibility = 'none' === this.node.style.display ? 'hidden' : 'visible', _;
      }

      if (null != t) s = {}, s[e] = t;else if (n.is(e, 'object')) s = e;else if (n.is(e, 'string')) return 'fill' === e && 'none' === f.fill && f.gradient ? f.gradient : 'transform' === e ? this._.transform : 'visibility' === e ? 'none' === this.node.style.display ? 'hidden' : 'visible' : e in f ? f[e] : n.is(y[e], 'function') ? y[e].def : n._availableAttrs[e];
      if (!n.stopPartialEventPropagation) for (r in s) {
        b('raphael.attr.' + r + '.' + this.id, this, s[r], r);
      }

      for (r in s) {
        if (c = y[r], c && !g[r] && n.is(c, 'function')) {
          for (d in g[r] = !0, l = c.apply(this, [].concat(s[r])), g[r] = !1, l) {
            u[d] = l[d];
          }

          f[r] = s[r];
        } else u[r] = s[r];
      }

      for (G(this, u), a = 0, o = this.followers.length; a < o; a++) {
        p = this.followers[a], p.cb && !p.cb.call(p.el, u, this) || p.el.attr(u);
      }

      return this;
    }, J.pinchstart = function (t, r) {
      var i = this,
          a = {},
          e = function e(o) {
        if (o.touches && 2 === o.touches.length) {
          var _e = o.touches[0],
              _s = o.touches[1];
          i._blockDrag = !0, o && o.preventDefault(), n.makeSelectiveCopy(a, o), a.data = {
            finger0: _e,
            finger1: _s,
            distanceX: W(_e, _s),
            distanceY: W(_e, _s, !0)
          }, t.call(r || i, a);
        } else i._blockDrag = !1;
      };

      q(i, t, e), i.node.addEventListener('touchstart', e);
    }, J.unpinchstart = function (e) {
      var t = this,
          r = Q(t, e);
      t.__blockDrag = !1, t._pinchDragStarted = !1, r && t.node.removeEventListener('touchstart', r);
    }, J.pinchmove = function (t, r) {
      var i = this,
          a = {},
          e = function e(o) {
        if (o.touches && 2 === o.touches.length) {
          var _e2 = o.touches[0],
              _s2 = o.touches[1];
          o && o.preventDefault(), i._pinchDragStarted = !0, n.makeSelectiveCopy(a, o), a.data = {
            finger0: _e2,
            finger1: _s2,
            distanceX: W(_e2, _s2),
            distanceY: W(_e2, _s2, !0)
          }, t.call(r || i, a);
        }
      };

      q(i, t, e), i.node.addEventListener('touchmove', e);
    }, J.unpinchmove = function (e) {
      var t = this,
          r = Q(t, e);
      r && t.node.removeEventListener('touchmove', r);
    }, J.pinchend = function (t, r) {
      var i = this,
          e = function e(a) {
        i._pinchDragStarted && (i._pinchDragStarted = !1, t.call(r || i, a));
      };

      q(i, t, e), i.node.addEventListener('touchend', e);
    }, J.unpinchend = function (e) {
      var t = this,
          r = Q(t, e);
      t._pinchDragStarted = !1, r && t.node.removeEventListener('touchend', r);
    }, J.pinch = function (e, t, r) {
      J.pinchstart.call(this, e), J.pinchin.call(this, t), J.pinchend.call(this, r);
    }, J.unpinch = function (e, t, r) {
      J.unpinchstart.call(this, e), J.unpinchin.call(this, t), J.unpinchend.call(this, r);
    }, J.fcwheel = function (t, r) {
      var i = this,
          a = {},
          e = function e(o) {
        o && o.preventDefault(), n.makeSelectiveCopy(a, o), t.call(r || i, a);
      };

      q(i, t, e), i.node.addEventListener('wheel', e);
    }, J.fcunwheel = function (e) {
      var t = this,
          r = Q(t, e);
      r && t.node.removeEventListener('wheel', r);
    }, J.on = function (e, t, r) {
      if (t && e) {
        var i,
            a,
            o = this,
            s = e.match(/fc-/),
            d = t;
        if (this.removed) return this;

        switch (o._actualListners || (o._actualListners = []), o._derivedListeners || (o._derivedListeners = []), e) {
          case 'fc-dragstart':
            return o.drag(null, t), o;

          case 'fc-dragmove':
            return o.drag(t), o;

          case 'fc-dragend':
            return o.drag(null, null, t), o;

          case 'fc-dbclick':
            return o.dbclick(t, r), o;

          case 'fc-pinchstart':
            return o.pinchstart(t, r), o;

          case 'fc-pinchmove':
            return o.pinchmove(t, r), o;

          case 'fc-pinchend':
            return o.pinchend(t, r), o;

          case 'fc-click':
            return o.fcclick(t, r), o;

          case 'fc-wheel':
            return o.fcwheel(t, r), o;
        }

        return s && (e = e.replace(/fc-/, '')), s && L && (a = e, e = (S ? n.safePointerEventMapping[e] : D[e]) || e, 'mouseout' === a && (d = function d(i) {
          S && L && !i.isPrimary || (N.elementInfo.push({
            el: r || o,
            callback: t
          }), N.srcElement = i.srcElement || i.target);
        }, e = S ? 'pointerover' : 'touchstart')), this._ && this._.RefImg && ('load' === e || 'error' === e) ? (i = this._.RefImg, d = function d(r) {
          S && L && !r.isPrimary || o.removed || t.call(o, r);
        }) : i = this.node, d === t && (d = function d(i) {
          S && L && !i.isPrimary || t.call(r || o, i);
        }), o._actualListners.push(t), o._derivedListeners.push(d), i.addEventListener ? i.addEventListener(e, d) : i['on' + e] = d, this;
      }
    }, J.off = function (e, t) {
      var r,
          i,
          a,
          o = this,
          s = t,
          d = e.match(/fc-/);
      if (this.removed || !o._actualListners || !e || !t) return this;
      return 'fc-dragstart' === e ? (o.undragstart(t), o) : 'fc-dragmove' === e ? (o.undragmove(t), o) : 'fc-dragend' === e ? (o.undragend(t), o) : 'fc-dbclick' === e ? (o.undbclick(t), o) : 'fc-pinchstart' === e ? (o.unpinchstart(t), o) : 'fc-pinchmove' === e ? (o.unpinchmove(t), o) : 'fc-pinchend' === e ? (o.unpinchend(t), o) : 'fc-click' === e ? (o.fcunclick(t), o) : 'fc-wheel' === e ? (o.fcunwheel(t), o) : (d && (e = e.replace(/fc-/, '')), s = t, d && L && (r = e, e = (S ? n.safePointerEventMapping[e] : D[e]) || e, 'mouseout' === r && (e = S ? 'pointerover' : 'touchstart')), a = this._ && this._.RefImg ? this._.RefImg : this.node, i = o._actualListners.indexOf(s), -1 !== i && (s = o._derivedListeners[i], o._actualListners.splice(i, 1), o._derivedListeners.splice(i, 1)), a.removeEventListener ? a.removeEventListener(e, s) : a['on' + e] = null, this);
    }, n._engine.path = function (e, t, r) {
      var i = O('path'),
          a = new X(i, e, r);
      return a.type = 'path', t && a.attr(t), a;
    }, n._engine.group = function (e, t, r) {
      var i = O('g'),
          a = new X(i, e, r);
      return a.type = 'group', a.canvas = a.node, a.top = a.bottom = null, a._id = t || '', t && i.setAttribute('class', 'raphael-group-' + a.id + '-' + t), a;
    }, n._engine.circle = function (e, t, r) {
      var i = O('circle'),
          a = new X(i, e, r);
      return a.type = 'circle', t && a.attr(t), a;
    }, n._engine.rect = function (e, t, r) {
      var i = O('rect'),
          a = new X(i, e, r);
      return a.type = 'rect', t.rx = t.ry = t.r, t && a.attr(t), a;
    }, n._engine.ellipse = function (e, t, r) {
      var i = O('ellipse'),
          a = new X(i, e, r);
      return a.type = 'ellipse', t && a.attr(t), a;
    }, n._engine.image = function (e, t, r) {
      var i = O('image'),
          a = new X(i, e, r, !0);
      return a._.group = r || e, a.type = 'image', i.setAttribute('preserveAspectRatio', 'none'), t && a.attr(t), a;
    }, n._engine.text = function (e, t, r, i) {
      var a = O('text'),
          n = new X(a, e, r);
      return n.type = 'text', i && n.css && n.css(i, void 0, !0), t && n.attr(t), n;
    }, n._engine.setSize = function (e, t) {
      return this.width = e || this.width, this.height = t || this.height, this.canvas.setAttribute('width', this.width), this.canvas.setAttribute('height', this.height), this._viewBox && this.setViewBox.apply(this, this._viewBox), this;
    }, n._engine.create = function () {
      var e,
          t = n._getContainer.apply(0, arguments),
          r = t && t.container,
          i = t.x,
          a = t.y,
          o = t.width,
          s = t.height;

      if (!r) throw new Error('SVG container not found.');
      var d,
          l = O('svg'),
          p = 'overflow:hidden;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-moz-user-select:-moz-none;-khtml-user-select:none;-ms-user-select:none;user-select:none;-o-user-select:none;cursor:default;vertical-align:middle;';
      return L && (n.isEdge ? p += 'touch-action:none;' : n.isFirefox && n.isWindows ? p += 'touch-action:none;' : n.isIE11 && (p += '-ms-touch-action:none;')), i = i || 0, a = a || 0, o = o || 512, s = s || 342, O(l, {
        height: s,
        version: 1.1,
        width: o,
        xmlns: 'http://www.w3.org/2000/svg'
      }), 1 === r ? (l.style.cssText = p + 'position:absolute;left:' + i + 'px;top:' + a + 'px', r = n._g.doc.body, r.appendChild(l), d = 1) : (l.style.cssText = p + 'position:relative', r.firstChild ? r.insertBefore(l, r.firstChild) : r.appendChild(l)), e = new n._Paper(), e.width = o, e.height = s, e.canvas = l, e.container = r, O(l, {
        id: 'raphael-paper-' + e.id
      }), e.clear(), e._left = e._top = 0, d && (e.renderfix = function () {}), e.renderfix(), e;
    }, n._engine.setViewBox = function (e, t, r, i, a) {
      b('raphael.setViewBox', this, this._viewBox, [e, t, r, i, a]);
      var n,
          o,
          s = p(r / this.width, i / this.height),
          d = this.top,
          l = a ? 'meet' : 'xMinYMin';
      if (null == e ? (this._vbSize && (s = 1), delete this._vbSize, n = '0 0 ' + this.width + ' ' + this.height) : (this._vbSize = s, n = e + ' ' + t + ' ' + r + ' ' + i), O(this.canvas, {
        viewBox: n,
        preserveAspectRatio: l
      }), s) for (; d;) {
        o = 'stroke-width' in d.attrs ? d.attrs['stroke-width'] : 1, d.attr({
          "stroke-width": o
        }), d._.dirty = 1, d._.dirtyT = 1, d = d.prev;
      }
      return this._viewBox = [e, t, r, i, !!a], this;
    }, n.prototype.detachPaper = function () {
      !1 !== this._detached && (this.container.removeChild(this.canvas), this._detached = !0);
    }, n.prototype.attachPaper = function () {
      this._detached && (this.container.appendChild(this.canvas), this._detached = !1);
    }, n.prototype.renderfix = function () {
      var e,
          t = this.canvas,
          r = t.style;

      try {
        e = t.getScreenCTM() || t.createSVGMatrix();
      } catch (r) {
        e = t.createSVGMatrix();
      }

      var i = -e.e % 1,
          a = -e.f % 1;
      (i || a) && (i && (this._left = (this._left + i) % 1, r.left = this._left + 'px'), a && (this._top = (this._top + a) % 1, r.top = this._top + 'px'));
    }, n.prototype._desc = function (e) {
      var t = this.desc;
      if (!t) this.desc = t = O('desc'), this.canvas.appendChild(t);else for (; t.firstChild;) {
        t.removeChild(t.firstChild);
      }
      t.appendChild(n._g.doc.createTextNode(n.is(e, 'string') ? e : 'Created with Red Rapha\xEBl ' + n.version));
    }, n.prototype.clear = function () {
      var e;

      for (b('raphael.clear', this); e = this.bottom;) {
        e.remove();
      }

      for (e = this.canvas; e.firstChild;) {
        e.removeChild(e.firstChild);
      }

      this.bottom = this.top = null, e.appendChild(this.desc = O('desc')), e.appendChild(this.defs = O('defs'));
    }, n.prototype.remove = function () {
      for (b('raphael.remove', this); e = this.bottom;) {
        e.remove();
      }

      for (var e in this.defs && this.defs.parentNode.removeChild(this.defs), this.desc && this.desc.parentNode.removeChild(this.desc), this.canvas.parentNode && this.canvas.parentNode.removeChild(this.canvas), this) {
        this[e] = 'function' == typeof this[e] ? n._removedFactory(e) : null;
      }

      this.removed = !0;
    }, n.prototype.setHTMLClassName = function () {};
  }
}